(ns humbleai.belt.vector
  "Pure vector utility functions")

(defn remove-elem-at
  "Remove element at index i from vector v in linear time"
  [v i]
  (into (subvec v 0 i)
        (subvec v (inc i))))

(defn remove-elem
  "Remove element x from vector v in linear time"
  [v x]
  (let [i (.indexOf v x)]
    (remove-elem-at v i)))

(defn toggle-membership
  "If present remove element x from vector v in linear time else conj x onto v"
  [v x]
  (let [i (.indexOf v x)]
    (if (neg? i)
      (conj v x)
      (remove-elem-at v i))))

(defn elem-present?
  "Is element x present in vector v?"
  [v x]
  (<= 0 (.indexOf v x)))
